import React, { memo } from 'react';
import { FixedSizeList } from 'react-window';

/**
 * Virtual scrolling list component for conversations
 */
const VirtualConversationList = ({
  conversations = [],
  selectedConversation = null,
  onConversationClick,
  height = 400,
  itemHeight = 100,
  hasMore = false,
  loading = false,
  observerTarget = null
}) => {
  const ConversationItem = memo(({ index, style, data }) => {
    const conv = data.conversations[index];
    if (!conv) return null;

    const isSelected = data.selectedId === conv.id;

    return (
      <div style={style}>
        <div
          onClick={() => data.onClick(conv)}
          className={`p-3 mx-2 mb-2 rounded-lg border cursor-pointer transition-colors ${
            isSelected
              ? 'border-blue-500 bg-blue-50'
              : 'border-gray-200 hover:bg-gray-50'
          }`}
        >
          <div className="flex justify-between items-start mb-2">
            <p className="font-medium text-sm">{conv.phone}</p>
            <span className="text-xs text-gray-500">{conv.duration}s</span>
          </div>
          <p className="text-xs text-gray-600">{conv.campaign_name}</p>
          <p className="text-xs text-gray-500 mt-1">
            {new Date(conv.created_at).toLocaleString('fr-FR')}
          </p>
          {conv.transcript && conv.transcript.length > 0 && (
            <p className="text-xs text-gray-600 mt-1">
              Messages: {conv.transcript.length}
            </p>
          )}
        </div>
      </div>
    );
  });

  ConversationItem.displayName = 'ConversationItem';

  if (conversations.length === 0) {
    return (
      <div className="flex items-center justify-center h-full text-gray-500">
        Aucune conversation trouvée
      </div>
    );
  }

  return (
    <div className="relative">
      <FixedSizeList
        height={height}
        itemCount={conversations.length}
        itemSize={itemHeight}
        width="100%"
        itemData={{
          conversations,
          selectedId: selectedConversation?.id,
          onClick: onConversationClick
        }}
        overscanCount={5}
      >
        {ConversationItem}
      </FixedSizeList>
      
      {(hasMore || loading) && (
        <div 
          ref={observerTarget} 
          className="h-10 flex items-center justify-center py-4"
        >
          {loading && <div className="text-gray-500">Loading more conversations...</div>}
        </div>
      )}
    </div>
  );
};

export default memo(VirtualConversationList);

